// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__s8IoR","title":"Info_title__3f9Rm","selects":"Info_selects__f7Eyt","requiredAsterisk":"Info_requiredAsterisk__3n17C"};